import { render, staticRenderFns } from "./supplierManage.vue?vue&type=template&id=2d2c4a65&scoped=true"
import script from "./supplierManage.vue?vue&type=script&lang=js"
export * from "./supplierManage.vue?vue&type=script&lang=js"
import style0 from "./supplierManage.vue?vue&type=style&index=0&id=2d2c4a65&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c4a65",
  null
  
)

export default component.exports